import calPic from "@/public/images/artists/cal.png";
import { Artist } from "@/types/types";

export const cal = {
  id: "281",
  name: "Cal",
  image: calPic,
  description: `Cal has a bright voice with controlled vibrato, steady delivery, and a clean tone throughout.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fcal-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: [
        "Unprocessed",
        "Alternative",
        "Indie",
        "Pop",
        "Dance",
        "Rock",
        "Ballads",
      ],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 52,
        high: 67,
      },
      sweetSpot: 58,
    },
  },
} satisfies Artist;
